import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { login, LoginActionType, loginFailed, loginSuccessful } from '../../actions/authentication/login';
import getPublicResponse from '../getPublicResponse';

function* authenticationSaga({ payload }: LoginActionType) {
  const { email, password } = payload;
  const timestamp = moment();
  const response = yield getPublicResponse(PublicServerPlaceEvent.authenticatePlace, { email, password });
  const { authenticationFailed, token, error } = response;
  if (!error && !authenticationFailed && token) {
    yield put(loginSuccessful({ token, timestamp }));
  } else {
    yield put(loginFailed({ authenticationFailed, timestamp }));
  }
}

export default function* watchAuthenticationSaga() {
  yield takeEvery(login, authenticationSaga);
}
